// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1780":"bb397c81e0abbf8e","5124":"8e13d14efa2b88ae"}[chunkId] + ".js";
};